import classes from './liveInteraktiv.module.css'
import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from './../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'

const LiveInteraktiv = () => {
  const [error, setError] = useState(false)
  const [apiError, setApiError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', '', ''],
      oddsG: ['', ''],
      oddsB: ['', ''],
      stats: ['', '', '', '', '', ''],
      resultsHalf: ['', ''],
      minutes: [''],
    },
    results: {
      goals: ['', '', ''],
      score: ['', '', '', '', '', ''],
      teamStrength: ['', '', '', '', '', '', '', ''],
    },
  })
  const allFieldsFilled = areAllFieldsFilled(data.values)

  const clearFields = () => {
    setData({
      values: {
        odds: ['', '', ''],
        oddsG: ['', ''],
        oddsB: ['', ''],
        stats: ['', '', '', '', '', ''],
        resultsHalf: ['', ''],
        minutes: [''],
      },
      results: {
        goals: ['', '', ''],
        score: ['', '', '', '', '', ''],
        teamStrength: ['', '', '', '', '', '', '', ''],
      },
    })
    setApiError(false)
    setShowInputArea(true)
  }

  const handleCalculateAll = async () => {
    const odds = data?.values?.odds || ['', '', '']
    const oddsG = data?.values?.oddsG || ['', '']
    const oddsB = data?.values?.oddsB || ['', '']
    const stats = data?.values?.stats || ['', '', '', '', '', '']
    const resultsHalf = data?.values?.resultsHalf || ['', '']
    const minutes = data?.values?.minutes || ['']

    const [odd1Str, oddXStr, odd2Str] = [
      odds[0] || '',
      odds[1] || '',
      odds[2] || '',
    ]
    const [odd02Str, odd30Str] = oddsG
    const [odd12Str, odd20Str] = oddsB
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      stats
    const [score1Str, score2Str] = resultsHalf
    const [minutesStr] = minutes

    const body = {
      oddsHome: parseFloat(odd1Str),
      oddsDraw: parseFloat(oddXStr),
      oddsAway: parseFloat(odd2Str),
      homeGoalsScored: parseFloat(wins1Str),
      homeGoalsConceded: parseFloat(losses1Str),
      homeMatchesPlayed: parseFloat(played1Str),
      awayGoalsScored: parseFloat(wins2Str),
      awayGoalsConceded: parseFloat(losses2Str),
      awayMatchesPlayed: parseFloat(played2Str),
      currentMatchMinute: parseFloat(minutesStr),
      halfTimeHomeScore: parseFloat(score1Str),
      halfTimeAwayScore: parseFloat(score2Str),
      oddsUnder25: parseFloat(odd02Str),
      oddsOver25: parseFloat(odd30Str),
      oddsBttsYes: parseFloat(odd12Str),
      oddsBttsNo: parseFloat(odd20Str),
    }

    setLoading(true)
    setApiError(false)
    try {
      const res = await runCalculator('predictions', 'football-live', body)

      const stats0 = res?.stats || {}
      const goals = res?.expectedRemainingGoals || {}
      const cs = res?.correctScore || {}
      const min = cs.minScenario || ['0 : 0', '0 : 0', '0 : 0']
      const mid = cs.averageScenario || ['0 : 0', '0 : 0', '0 : 0']
      const max = cs.maxScenario || ['0 : 0', '0 : 0', '0 : 0']

      const fix = (value) =>
        isNaN(parseFloat(value)) ? '0.00' : parseFloat(value).toFixed(2)

      setData((prevData) => ({
        ...prevData,
        results: {
          ...prevData.results,
          goals: [fix(goals.min), fix(goals.average), fix(goals.max)],
          score: [
            `${min[0]} \n\n${min[1]}`,
            `${mid[0]} \n\n${mid[1]}`,
            `${max[0]} \n\n${max[1]}`,
            min[2],
            mid[2],
            max[2],
          ],
          teamStrength: [
            fix(stats0.homeGoalsScoredAvg),
            fix(stats0.homeGoalsConcededAvg),
            fix(stats0.awayGoalsConcededAvg),
            fix(stats0.awayGoalsScoredAvg),
            fix(stats0.homeScoredAwayConcededAvg),
            fix(stats0.homeConcededAwayScoredAvg),
            fix(stats0.homeAwayScoredAvg),
            fix(stats0.homeAwayConcededAvg),
          ],
        },
      }))
      return true
    } catch (err) {
      setApiError(true)
      return false
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (allFieldsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allFieldsFilled])

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = async () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    const ok = await handleCalculateAll()
    if (ok) {
      setShowInputArea((prev) => !prev)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Live interaktiv`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled || loading}>
            {loading
              ? 'Obračun u toku...'
              : showInputArea
              ? 'Prikaži rezultate'
              : 'Unesi obračunske podatke'}
          </button>
        </div>
        {apiError && (
          <div className={classesK.sectionTitle}>
            Greška pri obračunu, pokušajte ponovo.
          </div>
        )}
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod meča
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI X', 'KI 2']}
                step={['0.1', '0.1', '0.1']}
                min={['0.1', '0.1', '0.1']}
                type={['number', 'number', 'number']}
                setError={setError}
                rows={3}
              />
              <div className={classesK.sectionTitle}>Upiši kvote za golove</div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'oddsG'}
                labelPrefix={[
                  'Manje od 2.5 ( UG 0-2 )',
                  'Više od 2.5 ( UG 3+ )',
                ]}
                step={['0.1', '0.1']}
                min={['1', '1']}
                type={['number', 'number']}
                setError={setError}
                rows={1}
              />
              <div className={classesK.sectionTitle}>
                Upiši kvote za "Oba daju gol"
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'oddsB'}
                labelPrefix={[
                  'GG  ( oba tima daju gol na ut.)',
                  'NEGG ( min. jedan tim ne daje gol na ut. )',
                ]}
                step={['1', '1']}
                min={['1', '1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />
              <div className={classesK.sectionTitle}>
                Upiši br. golova / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'stats'}
                labelPrefix={[
                  'DOM + (dom. dao golova)',
                  'DOM - (dom. primio golova)',
                  'DOM BR. (dom. odigrao utakmica)',
                  'GOST + (gost dao golova)',
                  'GOST - (gost primio golova)',
                  'GOST BR. (gost odigrao utakmica)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['1', '1', '1', '1', '1', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
              />
              <div className={classesK.sectionTitle}>
                Upiši rezultat prvog poluvremena
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'resultsHalf'}
                labelPrefix={[
                  'DOM ( dom. dao golova )',
                  'GOST ( gost dao golova)',
                ]}
                step={['1', '1']}
                min={['0', '0']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />
              <div className={classesK.sectionTitle}>
                Upiši trenutni minut igre na utakmici
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'minutes'}
                labelPrefix={['MINUT( koji je minut utakmice ? )']}
                step={['1']}
                min={['0']}
                type={['number', 'number']}
                setError={setError}
                rows={1}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Golovi'}
              subtitle={'XG ( očekivani br. golova do kraja utak.)'}
              results={data?.results?.goals.map((result) => `${result}`)}
              names={[
                'Minimalni očekivani broj golova',
                'Srednji očekivani broj golova',
                'Maksimalni očekivani broj golova',
              ]}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={'TR u preostalom vremenu utakmice'}
              results={[
                data?.results?.score[0],
                data?.results?.score[1],
                data?.results?.score[2],
              ]}
              names={[
                'Minimalan TR u preostalom vremenu',
                'Srednji TR u preostalom vremenu',
                'Maksimalan TR u preostalom vremenu',
              ]}
              rows={2}
            />
            <ResultsSection
              subtitle={'TR na kraju utakmice'}
              results={[
                data?.results?.score[3],
                data?.results?.score[4],
                data?.results?.score[5],
              ]}
              names={[
                'Predikcija minimalnog Tr-a na kraju ut. ',
                'Predikcija srednjeg Tr-a na kraju ut.',
                'Predikcija maximalnog Tr-a na kraju ut.',
              ]}
              rows={2}
            />

            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrength[0],
                data.results?.teamStrength[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrength[2],
                data.results?.teamStrength[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrength[4],
                data.results?.teamStrength[5],
              ]}
              names={['SNDG ( snaga napada )', 'SODG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Tim proseci odbrana i napada'}
              results={[
                data?.results?.teamStrength[6],
                data.results?.teamStrength[7],
              ]}
              names={[
                'SND+SOG ( snaga napada domaćin + snaga odbrane gost )',
                'SOD+SNG ( snaga napada domaćin + snaga odbrane gost )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default LiveInteraktiv
